export default {
  root: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      fontSize: 14,
      color: '#333'
    },
    '& $button': {
      display: 'flex',
      alignItems: 'center',
      border: 'none',
      cursor: 'pointer',
      '&:hover': {
        border: 'none',
        background: 'transparent'
      },
      '& svg': {
        fill: '#fff'
      }
    }
  },
  button: {},
  iconWrap: {
    borderRadius: 32,
    background: '#008ff5',
    height: 36,
    width: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8
  }
};
